import { XSnackbar } from '@adornis/chemistry/elements/components/x-snackbar.js';
import '@adornis/forms/x-input.js';
import '@adornis/forms/x-textarea.js';
import { stateful, useState } from '@adornis/functional-lit/stateful.js';
import { useGeneratedForm } from '@adornis/generated-form/use-generated-form.js';
import { html } from 'lit';
import * as m from '../../../../localization/out/messages.js';
import { Company } from '../../../db/company.js';
import { formatFormError } from '../../components/format-form-error.js';
import { entityValidator, translateValidationError } from '../../components/form-validation.js';
import { labeledField } from '../../components/labeled-field.js';
import { adminRouter } from './admin-routes.js';

export const AdminCreateCompany = stateful(() => {
  const [company, setCompany] = useState(new Company({}));
  const { form, renderField } = useGeneratedForm(
    company,
    {
      translationPrefix: 'company_profile_',
      validator: entityValidator(Company, ['name']),
      translateError: translateValidationError,
    },
    [company],
  );

  const handleCreate = async () => {
    const err = await form.validate();
    if (err) {
      void XSnackbar.show(formatFormError(err, 'company_profile_'));
      return;
    }
    try {
      await form.uploadAllPendingFiles();
      await company.create();
      setCompany(new Company({}));
      adminRouter.goTo('root');
    } catch (e) {
      console.error(e);
      void XSnackbar.show(formatFormError(e, 'company_profile_'));
    }
  };

  return html`
    <div>
      <div class="flex flex-col gap-4 mb-6">
        <button @click=${() => adminRouter.goTo('root')} class="btn btn-ghost self-start">
          <span class="icon-[material-symbols--arrow-back]"></span>
          ${m.back_to_list()}
        </button>
        <h1 class="text-2xl font-bold">${m.admin_create_company_title()}</h1>
      </div>
      <div class="card bg-base-100 shadow-xl">
        <div class="card-body gap-4">
          ${labeledField(m.company_profile_name_label(), renderField(['name']))}
          ${labeledField(m.company_profile_address_label(), renderField(['address']))}
          ${labeledField(m.company_profile_sector_label(), renderField(['sector']))}
          ${labeledField(m.company_profile_website_label(), renderField(['website']))}
          ${labeledField(m.company_profile_services_label(), renderField(['services']))}

          <div class="card-actions justify-end mt-4">
            <button @click=${() => adminRouter.goTo('root')} class="btn btn-ghost">${m.cancel()}</button>
            <button @click=${handleCreate} class="btn btn-primary">${m.admin_create_company_create_button()}</button>
          </div>
        </div>
      </div>
    </div>
  `;
});
